import { Component, ViewChild } from '@angular/core'
import { ReportParamDto, ReportRequest } from '../../../../api/models'
import * as moment from 'moment'
import { AppSettingService, ReportsService, RolesService } from '../../../../api/services'
import { MessageService } from 'primeng/api'
import { DatePipe } from '@angular/common'
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router'
import { combineLatest, filter, map, switchMap, tap } from 'rxjs'
import { CareFinitySession } from '../../../services/CareFinitySession'
import { ReportsViewParamsComponent } from '../reports-view-params/reports-view-params.component'

@Component({
  selector: 'app-report-view',
  templateUrl: './report-view.component.html',
  styleUrl: './report-view.component.css',
})
export class ReportViewComponent {
  title: string = ''
  href: string
  visible: boolean
  report_Id: number = -1
  report_DisplayName: string = ''
    popupDisplayReportsParams: boolean = false;

    setPrintFlag: boolean = false;

  public dropDownDataType = {
    number: 0,
    string: 1,
    date: 2,
    boolean: 3,
    currency: 4,
    dateTime: 5,
    time: 6,
  }

  constructor(
    private _reportService: ReportsService,
    private _messageService: MessageService,
    private _router: Router,
    public _activatedRoute: ActivatedRoute,
    private _datePipe: DatePipe,
      private _appSettingsService: AppSettingService
  ) {
    const state = history.state as {
      report_Id: number
        report_DisplayName: string
        report_Dsn: string
    }
    this.report_Id = state.report_Id
    this.report_DisplayName = state.report_DisplayName

    //this._router.events.pipe(
    //    filter(event => event instanceof NavigationEnd),
    //    filter(() => this._router.url.includes('/reports-view')) // Filter based on URL path
    //).subscribe(() => {
    //    const state = this._router.getCurrentNavigation()?.extras.state;
    //    this.report_Id = state.report_Id;
    //    this.report_DisplayName = state.report_DisplayName;
    //    this.openReportDetails(this.report_Id);
    //});
  }

  @ViewChild('reportsViewParams')
  reportsViewParamsComponent!: ReportsViewParamsComponent

  ngOnInit() {
    this.title = this.report_DisplayName
      this.openReportDetails(this.report_Id);

     
  }

  openReportDetails(reportID: number): void {
    this._reportService
      .reportsGetReportParams({
        reportId: reportID,
      })
      .subscribe(
        (resParamView) => {
          var autoMapCount = 0
          if (
            resParamView.reportParamList &&
            resParamView.reportParamList.length > 0
          ) {
            var paramsWithRequired = resParamView.reportParamList.filter(
              (r) => r.isrequired == true,
            )
            autoMapCount = paramsWithRequired.length
          }

          if (resParamView.reportParamList.length <= 0) {
            //return this.openReport(resParamView, null);
            var reportReq: ReportRequest = {}
            reportReq.fileName = resParamView?.report?.reportFileName
              reportReq.parameters = []
              reportReq.reportDsnName = resParamView.report.reportDsnName
            return this.openReport(resParamView, reportReq)
          } else if (autoMapCount == resParamView.reportParamList.length) {
            var reportReq: ReportRequest = {}
            reportReq.fileName = resParamView?.report?.reportFileName
              reportReq.parameters = []
              reportReq.reportDsnName = resParamView.report.reportDsnName
            resParamView.reportParamList.forEach((item) => {
              reportReq.parameters.push({
                key: item.reportparamname,
                value: this.getMacroValues(item.picklistValues),
              })
            })

            return this.openReport(resParamView, reportReq)
          } else {
            debugger
            this.popupDisplayReportsParams = true
            this.reportsViewParamsComponent.title =
              resParamView?.report?.reportShortNote
            this.reportsViewParamsComponent.reportParamDto = resParamView
          }
        },
        (err) =>
          this._messageService.add({
            key: 'alertToast',
            severity: 'error',
            summary: 'ERROR',
            detail: 'Report File missing, Please Contact Technical Support',
          }),
      )
  }

  onReportViewParam_Click(reportParamDto: ReportParamDto): void {
    debugger
    this.loadReport(reportParamDto)
  }

  /*
   **   This function which will loop through ReportParamList and check the values User has entered are valid or not,
   **   if values are not valid then it will show particular messages based on different DataTypes.
   */
  loadReport(reportParamDto: ReportParamDto): void {
    debugger
    var valid: boolean = false
    var result: boolean = false
    var param: ReportRequest = {}
    param.parameters = []

    valid = true
    reportParamDto.reportParamList.forEach((item) => {
      debugger
      if (item.isrequired) {
        param.parameters.push({
          key: item.reportparamname,
          value: this.getMacroValues(item.picklistValues),
        })
      } else {
        if (this.isNullOrWhiteSpace(item.value, item.datatype)) {
          this._messageService.add({
            key: 'alertToast',
            severity: 'error',
            summary: `Error - "${item.reportparamname}"`,
            detail: `Value for param "${item.reportparamshortnote}" required `,
            life: 5000,
          })
          valid = false
        } else {
          switch (Number(item.datatype)) {
            case this.dropDownDataType.date:
              /*if (!moment.isDate(item.value)) {*/
              if (!this.isDate(item.value)) {
                this._messageService.add({
                  key: 'alertToast',
                  severity: 'error',
                  summary: `Error - "${item.reportparamname}"`,
                  detail: `Invalid value for param "${item.reportparamshortnote}" date value required `,
                  life: 5000,
                })
                valid = false
              } else if (
                /*else if (moment.isDate(item.mindate) && moment(item.value, 'YYYY-MM-DD').toDate() < moment(item.mindate, 'YYYY-MM-DD').toDate()) {*/
                this.isDate(item.mindate) &&
                moment(item.value, 'YYYY-MM-DD').toDate() <
                  moment(item.mindate, 'YYYY-MM-DD').toDate()
              ) {
                valid = false
                this._messageService.add({
                  key: 'alertToast',
                  severity: 'error',
                  summary: `Error - "${item.reportparamname}"`,
                  detail: `Invalid value for param "${item.reportparamshortnote}" a value >= "${item.mindate}" required `,
                  life: 5000,
                })
              } else if (
                this.isDate(item.maxdate) &&
                moment(item.value, 'YYYY-MM-DD').toDate() >
                  moment(item.maxdate, 'YYYY-MM-DD').toDate()
              ) {
                valid = false
                this._messageService.add({
                  key: 'alertToast',
                  severity: 'error',
                  summary: `Error - "${item.reportparamname}"`,
                  detail: `Invalid value for param "${item.reportparamshortnote}" a value <= "${item.maxdate}" required `,
                  life: 5000,
                })
              }
              break

            case this.dropDownDataType.dateTime:
              /*if (!moment.isDate(item.value)) {*/
              if (!this.isDate(item.value)) {
                this._messageService.add({
                  key: 'alertToast',
                  severity: 'error',
                  summary: `Error - "${item.reportparamname}"`,
                  detail: `Invalid value for param "${item.reportparamshortnote}" date value required `,
                  life: 5000,
                })
                valid = false
              } else {
                let startDateTime = new Date()
                let endDateTime = new Date()
                if (item.startDateTime.trim().length > 0) {
                  startDateTime = moment(item.startDateTime).toDate()
                }

                if (item.endDateTime.trim().length > 0) {
                  endDateTime = moment(item.endDateTime).toDate()
                }

                if (
                  item.startDateTime.trim().length > 0 &&
                  moment(item.value).toDate() < startDateTime
                ) {
                  valid = false
                  this._messageService.add({
                    key: 'alertToast',
                    severity: 'error',
                    summary: `Error - "${item.reportparamname}"`,
                    detail: `Invalid value for param "${item.reportparamshortnote}" a value >= "${item.startDateTime}" required `,
                    life: 5000,
                  })
                } else if (
                  item.endDateTime.trim().length > 0 &&
                  moment(item.value).toDate() > endDateTime
                ) {
                  valid = false
                  this._messageService.add({
                    key: 'alertToast',
                    severity: 'error',
                    summary: `Error - "${item.reportparamname}"`,
                    detail: `Invalid value for param "${item.reportparamshortnote}" a value <= "${item.endDateTime}" required `,
                    life: 5000,
                  })
                }
              }
              break

            case this.dropDownDataType.time:
              /*if (!moment(item.value).toDate().getTime()) {*/
              if (!this.isTime(item.value)) {
                this._messageService.add({
                  key: 'alertToast',
                  severity: 'error',
                  summary: `Error - "${item.reportparamname}"`,
                  detail: `Invalid value for param "${item.reportparamshortnote}" time value required `,
                  life: 5000,
                })
                valid = false
              } else {
                let startTime = new Date()
                let endTime = new Date()

                if (item.startTime.trim().length > 0) {
                  startTime = moment(item.startTime).toDate()
                }

                if (item.endTime.trim().length > 0) {
                  endTime = moment(item.endTime).toDate()
                }

                if (
                  item.startTime.trim().length > 0 &&
                  moment(item.value).toDate() < startTime
                ) {
                  valid = false
                  this._messageService.add({
                    key: 'alertToast',
                    severity: 'error',
                    summary: `Error - "${item.reportparamname}"`,
                    detail: `Invalid value for param "${item.reportparamshortnote}" a value >= "${item.startTime}" required `,
                    life: 5000,
                  })
                } else if (
                  item.endTime.trim().length > 0 &&
                  moment(item.value).toDate() > endTime
                ) {
                  valid = false
                  this._messageService.add({
                    key: 'alertToast',
                    severity: 'error',
                    summary: `Error - "${item.reportparamname}"`,
                    detail: `Invalid value for param "${item.reportparamshortnote}" a value <= "${item.startTime}" required `,
                    life: 5000,
                  })
                }
              }
              break

            case this.dropDownDataType.number:
              if (!this.isNumber(item.value)) {
                valid = false
                this._messageService.add({
                  key: 'alertToast',
                  severity: 'error',
                  summary: `Error - "${item.reportparamname}"`,
                  detail: `Invalid value for param "${item.reportparamshortnote}" numeric value required `,
                  life: 5000,
                })
              } else if (
                this.isNumber(item.minnumber) &&
                parseFloat(item.value) < parseFloat(item.minnumber)
              ) {
                valid = false
                this._messageService.add({
                  key: 'alertToast',
                  severity: 'error',
                  summary: `Error - "${item.reportparamname}"`,
                  detail: `Invalid value for param "${item.reportparamshortnote}" a value >= "${item.minnumber}" required `,
                  life: 5000,
                })
              } else if (
                this.isNumber(item.maxnumber) &&
                parseFloat(item.value) > parseFloat(item.maxnumber)
              ) {
                valid = false
                this._messageService.add({
                  key: 'alertToast',
                  severity: 'error',
                  summary: `Error - "${item.reportparamname}"`,
                  detail: `Invalid value for param "${item.reportparamshortnote}" a value <= "${item.maxnumber}" required `,
                  life: 5000,
                })
              }
              break

            case this.dropDownDataType.currency:
              if (!this.isNumber(item.value)) {
                valid = false
                this._messageService.add({
                  key: 'alertToast',
                  severity: 'error',
                  summary: `Error - "${item.reportparamname}"`,
                  detail: `Invalid value for param "${item.reportparamshortnote}" numeric value required `,
                  life: 5000,
                })
              } else if (
                this.isNumber(item.minCurrency) &&
                parseFloat(item.value) < parseFloat(item.minCurrency)
              ) {
                valid = false
                this._messageService.add({
                  key: 'alertToast',
                  severity: 'error',
                  summary: `Error - "${item.reportparamname}"`,
                  detail: `Invalid value for param "${item.reportparamshortnote}" a value >= "${item.minCurrency}" required `,
                  life: 5000,
                })
              } else if (
                this.isNumber(item.maxCurrency) &&
                parseFloat(item.value) > parseFloat(item.maxCurrency)
              ) {
                valid = false
                this._messageService.add({
                  key: 'alertToast',
                  severity: 'error',
                  summary: `Error - "${item.reportparamname}"`,
                  detail: `Invalid value for param "${item.reportparamshortnote}" a value <= "${item.maxCurrency}" required `,
                  life: 5000,
                })
              }
              break

            case this.dropDownDataType.string:
              if (
                this.isNumber(
                  item.maxstringlength ? item.maxstringlength.toString() : '',
                ) &&
                item.value.length >
                  parseFloat(
                    item.maxstringlength
                      ? item.maxstringlength.toString()
                      : '0',
                  ) &&
                parseFloat(
                  item.maxstringlength ? item.maxstringlength.toString() : '0',
                ) > 0
              ) {
                valid = false
                this._messageService.add({
                  key: 'alertToast',
                  severity: 'error',
                  summary: `Error - "${item.reportparamname}"`,
                  detail: `Invalid value for param "${item.reportparamshortnote}" a value <= "${item.maxstringlength}" required `,
                  life: 5000,
                })
              }
              break

            case this.dropDownDataType.boolean:
              break
          }
        }

        debugger
        if (valid) {
          if (Number(item.datatype) === this.dropDownDataType.date) {
            param.parameters.push({
              key: item.reportparamname,
              value: this._datePipe.transform(item.value, 'MM/dd/yyyy'),
            })
          } else if (Number(item.datatype) === this.dropDownDataType.dateTime) {
            param.parameters.push({
              key: item.reportparamname,
              value: this._datePipe.transform(
                item.value,
                'MM/dd/yyyy HH:mm:ss',
              ),
            })
          } else if (Number(item.datatype) === this.dropDownDataType.time) {
            param.parameters.push({
              key: item.reportparamname,
              value: this._datePipe.transform(
                item.value,
                'MM/dd/yyyy HH:mm:ss',
              ),
            })
          } else if (Number(item.datatype) === this.dropDownDataType.boolean) {
            param.parameters.push({
              key: item.reportparamname,
              value: item.value == 'true' ? '1' : '0',
            })
          } else {
            param.parameters.push({
              key: item.reportparamname,
              value: item.value.toString(),
            })
          }
        }
      }
    })

    if (valid) {
      var reportReq: ReportRequest = {}
      reportReq.fileName = reportParamDto.report.reportFileName
        reportReq.parameters = param.parameters
        reportReq.reportDsnName = reportParamDto.report.reportDsnName

      return this.openReport(reportParamDto, reportReq)
    } else {
      this.popupDisplayReportsParams = true
    }
    }




    openReport(paramView: ReportParamDto, request: ReportRequest): void

    {

      //  alert("hhh"); 

    this._reportService.reportsCreatePdf({ body: request }).subscribe(
      (resReportDTO) => {
        this._reportService
          .reportsGetReports({ fn: resReportDTO.pdfFileName })
          .subscribe(
            (file) => {
              if (resReportDTO.flexPaper) {
                this._router.navigate(['show-pdf'], {
                  relativeTo: this._activatedRoute,
                  state: {
                      pdf: file,
                      showPrintButton: CareFinitySession?.practiceSettings?.enablePatientDemographicPrint && CareFinitySession?.user?.roles?.patientRecordsPrint,
                      enabledDocumentDownloads: CareFinitySession?.practiceSettings?.enableDocumentDownloads && CareFinitySession?.user?.roles?.enableDocumentDownloads

                  },
                })
              } else
              {
                const dataType = file.type
                const binaryData = []
                binaryData.push(file)
                const downloadLink = document.createElement('a')
                downloadLink.href = window.URL.createObjectURL(
                  new Blob(binaryData, { type: dataType }),
                )
                this.href = downloadLink.href
                this.visible = true
                downloadLink.target = '_blank'
                downloadLink.setAttribute('inline', 'irfan')
                document.body.appendChild(downloadLink)
                downloadLink.click()
              }
            },
            (err) => {
              console.error('Error fetching report:', err)
              this._messageService.add({
                key: 'alertToast',
                severity: 'error',
                summary: 'ERROR',
                detail:
                  'Failed to fetch the report file. Please contact technical support.',
              })
            },
          )
      },
      (err) => {
        console.error('Error creating PDF report:', err)
        this._messageService.add({
          key: 'alertToast',
          severity: 'error',
          summary: 'ERROR',
          detail:
            'Failed to create the PDF report. Please contact technical support.',
        })
      },
    )
  }

    openReport1(paramView: ReportParamDto, request: ReportRequest): void {



                this._reportService.reportsCreatePdf({ body: request }).pipe(
            switchMap((resReportDTO) =>
                this._reportService.reportsGetReports({ fn: resReportDTO.pdfFileName }).pipe(
                    map((file) => ({ file, resReportDTO })) // pass both for next step
                )
            )
        ).subscribe({
            next: ({ file, resReportDTO }) => {
                if (resReportDTO.flexPaper) {
                    this._router.navigate(['show-pdf'], {
                        relativeTo: this._activatedRoute,
                        state: {
                            pdf: file,
                            showPrintButton: CareFinitySession?.practiceSettings?.enablePatientDemographicPrint && CareFinitySession?.user?.roles?.patientRecordsPrint,
                            enabledDocumentDownloads: CareFinitySession?.practiceSettings?.enableDocumentDownloads

                        }
                    });
                } else {
                    const dataType = file.type;
                    const binaryData = [file];
                    const downloadLink = document.createElement('a');
                    downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
                    this.href = downloadLink.href;
                    this.visible = true;
                    downloadLink.target = '_blank';
                    downloadLink.setAttribute('inline', 'irfan');
                    document.body.appendChild(downloadLink);
                    downloadLink.click();
                }
            },
            error: (err) => {
                console.error('Error during PDF handling:', err);
                this._messageService.add({
                    key: 'alertToast',
                    severity: 'error',
                    summary: 'ERROR',
                    detail: 'Failed to process the report. Please contact technical support.'
                });
            }
        });

    }




  isNullOrWhiteSpace(
    val: string | null | undefined,
    dataType: string,
  ): boolean {
    debugger
    var result = false
    if (Number(dataType) == this.dropDownDataType.date) {
      if (this._datePipe.transform(val, 'MM/dd/yyyy')) {
        result = false
      }
    } else if (Number(dataType) == this.dropDownDataType.dateTime) {
      if (this._datePipe.transform(val, 'MM/dd/yyyy HH:mm:ss')) {
        result = false
      }
    } else if (Number(dataType) == this.dropDownDataType.number) {
      return !val || val.length === 0
    } else if (Number(dataType) == this.dropDownDataType.time) {
      if (this._datePipe.transform(val, 'HH:mm:ss')) {
        result = false
      }
    } else if (Number(dataType) == this.dropDownDataType.boolean) {
      return !val || val.length === 0
    } else if (Number(dataType) == this.dropDownDataType.currency) {
      return !val || val.length === 0
    } else {
      return !val || val.trim().length === 0
    }
  }

  getMacroValues(mapp: string) {
    var result: string = ''
    switch (mapp.toUpperCase()) {
      case 'PERSONID': {
        result = sessionStorage.getItem('ptId')
        break
      }
      case 'PATIENTID': {
        result = sessionStorage.getItem('ptId')
        break
      }
      case 'EHRUSERID': {
        result = CareFinitySession.userPractices[0].defaultEHRUserId.toString()
        break
      }
      case 'USERID': {
        result = CareFinitySession.user.userID.toString()
        break
      }
      case 'ENTERPRISEID': {
        result = localStorage.getItem('EnterpriseID')
        break
      }
      case 'PRACTICEID': {
        result = localStorage.getItem('EmrPracticeId')
        break
      }
      case 'PROVIDERID': {
        result = localStorage.getItem('DefaultProviderId')
        break
      }
    }

    return result
  }

  isNullOrBlank(aValue: any, defaultValue: any): any {
    if (
      aValue === undefined ||
      aValue === null ||
      aValue === '' ||
      aValue === 'undefined'
    ) {
      return defaultValue
    }
    return aValue
  }

  isDate(aValue: string): boolean {
    try {
      if (!aValue) {
        return false
      }

      return moment(aValue).isValid()
    } catch {}
    return false
  }

  isTime(aValue: string): boolean {
    try {
      const dateString = '2011-10-09 ' + aValue
      moment(dateString, 'YYYY-MM-DD HH:mm:ss', true) // Ensure to adjust the format as per your requirement

      return true
    } catch {}
    return false
  }

  isNumber(aValue: string): boolean {
    try {
      Number.parseFloat(aValue)
      return true
    } catch {}
    return false
  }

  back() {
    //window.history.back()
      this._router.navigate(['/Patient/dashboard'])
      //this._router.navigate(['/Patient/dashboard']).then(() => {
      //    window.location.reload();
      //});
  }
}
